exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon__2pMZy{width:16px;height:16px;border-radius:8px;background-color:red;position:absolute;line-height:16px;font-size:10px;font-weight:600;right:-8px;top:-6px;text-align:center}", "", {"version":3,"sources":["/opt/build/repo/src/components/Icon/Icon.styles.scss"],"names":[],"mappings":"AAAA,aACE,WACA,YACA,kBACA,qBACA,kBACA,iBACA,eACA,gBACA,WACA,SACA,iBAAkB,CACnB","file":"Icon.styles.scss","sourcesContent":[".icon {\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  background-color: red;\n  position: absolute;\n  line-height: 16px;\n  font-size: 10px;\n  font-weight: 600;\n  right: -8px;\n  top: -6px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "icon__2pMZy"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/Icon/Icon.styles.scss
// module id = KJs9
// module chunks = 0